import { FiClock, FiMapPin, FiScissors, FiTag } from "react-icons/fi";
import Button from "../common/Button";
import formatCurrency from "../../utils/formatCurrency";
import {
  MOBILE_MODE_DESCRIPTION,
  STUDIO_MODE_DESCRIPTION,
} from "../../utils/constants";

const ServiceDetails = ({
  service,
  onBookNow,
  showBookingButton = true,
  className = "",
}) => {
  if (!service) {
    return (
      <div className={`content-card-lg p-6 ${className}`}>
        <p className="text-sm text-muted-warm">Service details are not available right now.</p>
      </div>
    );
  }

  return (
    <div className={`content-card-lg overflow-hidden ${className}`}>
      {service?.serviceImageUrl ? (
        <div className="h-72 w-full overflow-hidden bg-soft-cream">
          <img
            src={service.serviceImageUrl}
            alt={service.serviceName || "Henna service"}
            className="h-full w-full object-cover"
          />
        </div>
      ) : (
        <div className="hero-overlay flex h-72 items-center justify-center text-white">
          <div className="text-center">
            <FiScissors size={40} className="mx-auto" />
            <p className="mt-4 text-sm font-semibold uppercase tracking-[0.2em]">
              Nayra Henna Service
            </p>
          </div>
        </div>
      )}

      <div className="p-6 md:p-8">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
          <div className="min-w-0">
            <h2 className="text-3xl font-semibold text-henna">
              {service?.serviceName || "Service"}
            </h2>

            <div className="mt-4 flex flex-wrap gap-3">
              {service?.serviceType ? (
                <span className="badge-soft">
                  <FiTag size={14} />
                  {service.serviceType}
                </span>
              ) : null}

              {service?.hennaType ? (
                <span className="badge-soft">
                  <FiScissors size={14} />
                  {service.hennaType}
                </span>
              ) : null}

              {service?.serviceDurationMinutes ? (
                <span className="badge-soft">
                  <FiClock size={14} />
                  {service.serviceDurationMinutes} min
                </span>
              ) : null}
            </div>
          </div>

          <div className="shrink-0 rounded-2xl bg-soft-cream px-5 py-4 text-left lg:text-right">
            <p className="text-xs font-semibold uppercase tracking-wide text-golddeep">
              Starting Price
            </p>
            <p className="mt-1 text-2xl font-semibold text-henna">
              {service?.servicePrice !== undefined && service?.servicePrice !== null
                ? formatCurrency(service.servicePrice)
                : "Contact for pricing"}
            </p>
          </div>
        </div>

        {service?.serviceDescription ? (
          <div className="mt-6">
            <p className="text-sm font-semibold text-[#3b2f2f]">About This Service</p>
            <p className="mt-2 text-sm leading-7 text-muted-warm">
              {service.serviceDescription}
            </p>
          </div>
        ) : null}

        <div className="mt-8 grid gap-4 md:grid-cols-2">
          <div className="rounded-2xl bg-soft-cream p-5">
            <div className="flex items-center gap-2 text-henna">
              <FiMapPin />
              <p className="text-sm font-semibold">Studio Appointments</p>
            </div>
            <p className="mt-2 text-sm leading-6 text-muted-warm">
              {STUDIO_MODE_DESCRIPTION}
            </p>
          </div>

          <div className="rounded-2xl bg-soft-cream p-5">
            <div className="flex items-center gap-2 text-henna">
              <FiMapPin />
              <p className="text-sm font-semibold">Mobile Appointments</p>
            </div>
            <p className="mt-2 text-sm leading-6 text-muted-warm">
              {MOBILE_MODE_DESCRIPTION}
            </p>
          </div>
        </div>

        {showBookingButton ? (
          <div className="mt-8">
            <Button variant="primary" size="lg" onClick={onBookNow}>
              Book This Service
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ServiceDetails;